import React from 'react'
import Link from '../HeaderLink' 
import './index.css'

const SiteMap = (({map})=>(
	<div className="rows">
		{
			map && map ? map.map((_map)=>(
				<div className="row">
					{
						_map.map((col)=>(
							<div className="col">
								<Link text={col.link.caption} url={col.link.url} className='btn_site_map btn--h_site_map' />
								{
									col.childrens && col.childrens ? col.childrens.map((child)=>(
										<Link text={child.caption} url={child.url} className='btn_site_map' />		
									)): ''
								}
							</div>
						))
					}
				</div>	
			)): ''
		}
	</div>
))

export default SiteMap


// WEBPACK FOOTER //
// ./src/Components/SiteMap/index.js